export const MY_FEED = 'myFeed';
export const PROSPECT_3_0_DISCOVER = 'prospectWelcomeTrial';